import { Task } from '@repo/shared';
import { z } from 'zod';

export const metricSchema = z.object({
  output: z.string(),
  bleu: z.string().nullable(),
  comet: z.string().nullable(),
});

export type MetricSchema = z.infer<typeof metricSchema>;

export const clusterFiltersSchema = z.object({
  datasetId: z.string().optional(),
  task: z.nativeEnum(Task).optional(),
  models: z.array(z.string()).optional(),
  date: z
    .object({
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .optional(),
  createdBy: z.string().optional(),
  isEval: z.boolean().optional(),
});

export type ClusterFiltersSchema = z.infer<typeof clusterFiltersSchema>;
